import React, { forwardRef } from 'react'
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons'
import { Input } from 'antd'
import './index.css'

interface FormInputPasswordProps {
  Form: any;
  label?: React.ReactNode;
  name?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  rules?: any[];
  formItemStyles?: React.CSSProperties;
  validateStatus?: '' | 'success' | 'warning' | 'error' | 'validating';
  help?: React.ReactNode;
  [key: string]: any;
}

const FormInputPassword = forwardRef<any, FormInputPasswordProps>(
  (
    {
      Form,
      label,
      name,
      onChange,
      placeholder,
      rules = [],
      formItemStyles = {},
      validateStatus,
      help,
      ...extra
    },
    ref,
  ) => {
    return (
      <Form.Item
        className="v2FormInput"
        label={label}
        name={name}
        rules={rules}
        style={formItemStyles}
        validateStatus={validateStatus}
        help={help}
      >
        <Input.Password
          size="large"
          placeholder={placeholder}
          ref={ref}
          onChange={onChange}
          {...extra}
          iconRender={(visible: boolean) =>
            visible ? <EyeTwoTone twoToneColor="#6852D6" /> : <EyeInvisibleOutlined />
          }
        />
      </Form.Item>
    )
  },
)

export default FormInputPassword
